import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { useNavigate } from 'react-router-dom';
import { getUserSelector } from '../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { AppConstant } from '../../../../../../../Assests/AppConstant'
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import { getPoSSselector } from '../../../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import { usePrevious } from '../../../../../../Common/CustomHooks/usePrevious';
import './AllAppointmentsListSS.css';
import moment from 'moment-timezone';
import DrilldownTableSS from '../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import WarehouseSearchSS from '../../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import { CustomPaginationSS } from '../../../../../../Common/CustomPaginationSS/CustomPaginationSS';
import { smartScheduleSelector } from '../../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import { getRemoteConfigSelector } from '../../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import DownloadSectionBECustomFeilds from '../../../../DownloadSection/DownloadSectionBECustomFeilds';
import CustomDropDown from '../../../../../../Common/CustomDropDown/CustomDropDown';
import AppointmentReportHistory from './Components/AppointmentReportHistory';
import ModalSS from '../../../../../../SmartSchedule/SchedulePro/Components/Common/ModalSS/ModalSS';
import UploadSproDocumentsPopup from '../../../../../../Common/UploadSproDocumentsPopup/UploadSproDocumentsPopup';
import SSPopup from '../../../../../../Common/Popup/SSPopup/SSPopup';
import PoDetailsPopup from '../../../../../../Common/PoDetailsPopup/PoDetailsPopup';
import { formatDate_MM_DD_YYYY, shouldHavePermission } from '../../../../../../../Assests/Utility';
import DatePickerSS from '../../../../../../DatePickerSS/DatePickerSS';
import WarehouseFiltersForReports from './Components/WarehouseFiltersForReports';
import { getLocalDateString } from '../../../../../../../../Utils/DateUtils';


const AllAppointmentsListSS = (props) => {
    const { themeSelected = 'light-mode' } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [allApptsArr, setAllApptsArr] = useState([]);
    const pOSS = useSelector(getPoSSselector);
    const { myAppointmentsList, arrangeOrder, arrangeKey, myAppointmentsListResponse, apptsReportHistoryList, isLoading } = pOSS;
    const userObj = useSelector(getUserSelector);
    const [searchStr, setSearchStr] = useState(null);
    const { selectedWarehouse, userType, userAccountDetails, permissions } = userObj;
    const [currentTable, setCurrentTable] = useState(null);
    const [currentTableRef, setCurrentTableRef] = useState(null);
    const divRef = useRef(null);
    const [showLoading, setShowLoading] = useState(true);
    const previousTable = usePrevious(currentTable);
    const ss = useSelector(smartScheduleSelector);
    const { isDownloadLoading, initateLoading, appointmentDocumentsList, isActiveCommanDownloadPopup, commanDownloadMessage, startDate, endDate } = ss;
    moment.tz.setDefault(selectedWarehouse?.TimeZone)
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration;
    const [currentFilterSelected, setCurrentFilterSelected] = useState(null);
    const [currentUserTypeFilterSelected, setCurrentUserTypeFilterSelected] = useState({ name: 'All User' });
    const [currentWarehouseFilterSelected, setCurrentWarehouseFilterSelected] = useState(null);
    const [downloadWarehouseFilterSelected, setDownloadWarehouseFilterSelected] = useState(null);
    const [showAppointmentHistoryModal, setShowAppointmentHistoryModal] = useState(false);
    const [apptNumber, setapptNumber] = useState(null);
    const [showUploadDocsModal, setShowUploadDocsModal] = useState(false)
    const [popupshowMorePoObj, setPopupshowMorePoObj] = useState(null)
    const [showPoDetailsModal, setShowPoDetailsModal] = useState(false)
    const [selectedPo, setSelectedPo] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(null)
    const [selectedEndDate, setSelectedEndDate] = useState(null)
    const [showEndDate, setShowEndDate] = useState(false)
    const [showStartDate, setShowStartDate] = useState(false)
    const [allowPermission, setAllowPermission] = useState(false);
    const [dateRangeMode, setDateRangeMode] = useState('last30'); // 'last30' | 'last60' | 'custom'

    useEffect(() => {
        if (permissions.length) {
            const warehouseManagementPermission = _.find(permissions, { 'FeatureID': '12', 'PageAccess': true });
            if (warehouseManagementPermission && !_.isEmpty(warehouseManagementPermission)) {
                let temp = shouldHavePermission(permissions, '1000');
                setAllowPermission(temp)
                if (temp) {
                    if (selectedWarehouse) {
                        const warehouseName = selectedWarehouse.ExternalSiteID
                            ? `${selectedWarehouse.ExternalSiteID} - ${selectedWarehouse.Name}`
                            : selectedWarehouse.Name;
                        setCurrentWarehouseFilterSelected({ ID: selectedWarehouse.ID, name: warehouseName })
                        setDownloadWarehouseFilterSelected({ ID: selectedWarehouse.ID, name: warehouseName })
                    }
                    else {
                        setCurrentWarehouseFilterSelected({ ID: null, name: 'All Warehouse' })
                        // For non-super-admin: default to current logged-in warehouse

                        setDownloadWarehouseFilterSelected({ ID: null, name: 'All Warehouse' })
                    }
                }
            }
        }
    }, [permissions])


    useEffect(() => {
        // Initialize with last 30 days by default
        const today = new Date();
        const start30 = new Date();
        start30.setDate(start30.getDate() - 30);
        setSelectedStartDate(start30);
        setSelectedEndDate(today);
    }, [])

    // Update dates when dateRangeMode changes
    useEffect(() => {
        if (dateRangeMode === 'last30') {
            const today = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 30);
            setSelectedStartDate(start);
            setSelectedEndDate(today);
        } else if (dateRangeMode === 'last60') {
            const today = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 60);
            setSelectedStartDate(start);
            setSelectedEndDate(today);
        } else if (dateRangeMode === 'custom') {
            // Default to next 7 days when choosing custom date range
            const today = new Date();
            const end = new Date();
            end.setDate(end.getDate() + 7);
            setSelectedStartDate(today);
            setSelectedEndDate(end);
        }
    }, [dateRangeMode])

    /**
     * useEffect to set start date in redux
     */
    useEffect(() => {
        dispatch({ type: sagaActions.UPDATE_START_DATE, payload: new Date(selectedStartDate) })
        const getstartDate = () => {
            let d = new Date()
            // d.setMonth(d.getMonth()-1)
            return d
        }
        return (() => dispatch({ type: sagaActions.UPDATE_START_DATE, payload: getstartDate() }))
    }, [selectedStartDate])

    /**
     * useEffect to set end date in redux
     */
    useEffect(() => {
        dispatch({ type: sagaActions.UPDATE_END_DATE, payload: new Date(selectedEndDate) })
        return (() => dispatch({ type: sagaActions.UPDATE_END_DATE, payload: new Date() }))
    }, [selectedEndDate])

    useEffect(() => {
        if (selectedStartDate && selectedEndDate) {
            setTimeout(() => {
                // getApptSummary()
            }, [0])
        }
    }, [selectedStartDate, selectedEndDate])



    useEffect(() => {
        dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP })
        return () => {
            dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP })
        }
    }, [])

    useEffect(() => {
        if (showUploadDocsModal) {
            fetchUploadDocsDataForAppt()
        }

    }, [showUploadDocsModal])

    useEffect(() => {
        if (isActiveCommanDownloadPopup) {
            const popupshowMorePoObj = {
                id: 'popupshowMorePoObj',
                modalLabel: 'showMorePo',
                showClose: true,
                showfooter: true,
                showHeader: true,
                sendDriverNotification: false,
                modalSize: 'md',
                title: AppConstant.reports.downloadReportPopup.title,
                bodyText: (
                    <div>
                        <div>{commanDownloadMessage}</div>
                        <p className='mt-2 mb-0'>{AppConstant.reports.downloadReportPopup.hintPrefix}<strong>{AppConstant.reports.downloadReportPopup.myReportsBtn}</strong>{AppConstant.reports.downloadReportPopup.hintSuffix}</p>
                    </div>
                ),
                subText: "",
                keyboard: false,
                backdrop: "static",
                footerBtn: {
                    btn1: {
                        show: true,
                        text: AppConstant.reports.downloadReportPopup.myReportsBtn
                    },
                    btn2: {
                        show: true,
                        text: AppConstant.commonStrings.close
                    }
                },
            }
            setPopupshowMorePoObj({ ...popupshowMorePoObj })
        } else {
            setPopupshowMorePoObj(null)
        }
    }, [isActiveCommanDownloadPopup])


    const apptsTitleDD = [

        { id: 'serial_num', name: 'S.No' },
        { id: 'ApptNumber', name: 'Appt Number' },
        { id: 'PoNumber', name: 'PO/SO' },
        { id: userType === 'CARRIER' ? 'WarehouseName' : 'CarrierName', name: userType === 'CARRIER' ? 'Warehouse' : 'Carrier' },
        { id: 'DueDate', name: 'Due Date' },
        { id: 'ApptStartTime', name: 'Appt Date & Time' },
        { id: 'DockName', name: 'Dock' },
        // { id: 'BuyerName', name: 'Buyer' },
        { id: 'Pallets', name: 'Pallets' },
        { id: 'ItemsCases', name: AppConstant.smartScheduler.poSection.cases },
        { id: 'TransDate', name: 'Created On' },
        { id: 'ApptCreatedName', name: 'Scheduled By' },
        { id: 'Username', name: 'Created By' },
        { id: 'ApptScheStatus', name: 'Status' },
        { id: 'ReasonCode', name: 'Reason Code' },
        { id: 'Reason', name: 'Reason' },
        { id: 'TransDate', name: 'Created On' },
        { id: 'uploadDocs', name: 'Actions' },
        { id: 'Accordion', name: 'Multi PO/SO' }
    ]

    const apptsTitleDDWH = allowPermission ? [
        { id: 'serial_num', name: 'S.No' },
        { id: 'ApptNumber', name: 'Appt Number' },
        { id: 'PoNumber', name: 'PO/SO' },
        { id: userType === 'CARRIER' ? 'WarehouseName' : 'CarrierName', name: userType === 'CARRIER' ? 'Warehouse' : 'Carrier' },
        { id: 'DueDate', name: 'Due Date' },
        { id: 'ApptStartTime', name: 'Appt Date & Time' },
        { id: 'WarehouseName', name: 'Warehouse' },
        { id: 'DockName', name: 'Dock' },
        // { id: 'BuyerName', name: 'Buyer' },
        { id: 'Pallets', name: 'Pallets' },
        { id: 'ItemsCases', name: AppConstant.smartScheduler.poSection.cases },
        { id: 'TransDate', name: 'Created On' },
        { id: 'Username', name: 'Created By' },
        { id: 'ApptScheStatus', name: 'Status' },
        { id: 'ReasonCode', name: 'Reason Code' },
        { id: 'Reason', name: 'Reason' },
        { id: 'uploadDocs', name: 'Actions' },
        { id: 'Accordion', name: 'Multi PO/SO' }
    ] : [
        { id: 'serial_num', name: 'S.No' },
        { id: 'ApptNumber', name: 'Appt Number' },
        { id: 'PoNumber', name: 'PO/SO' },
        { id: userType === 'CARRIER' ? 'WarehouseName' : 'CarrierName', name: userType === 'CARRIER' ? 'Warehouse' : 'Carrier' },
        { id: 'DueDate', name: 'Due Date' },
        { id: 'ApptStartTime', name: 'Appt Date & Time' },
        { id: 'DockName', name: 'Dock' },
        // { id: 'BuyerName', name: 'Buyer' },
        { id: 'Pallets', name: 'Pallets' },
        { id: 'ItemsCases', name: AppConstant.smartScheduler.poSection.cases },
        { id: 'TransDate', name: 'Created On' },
        { id: 'Username', name: 'Created By' },
        { id: 'ApptScheStatus', name: 'Status' },
        { id: 'ReasonCode', name: 'Reason Code' },
        { id: 'Reason', name: 'Reason' },
        // { id: 'TransDate', name: 'Updated On' },
        { id: 'uploadDocs', name: 'Actions' },
        { id: 'Accordion', name: 'Multi PO/SO' }
    ]

    useEffect(() => {
        const container = divRef.current;
        const tables = container.querySelectorAll('table');
        if (tables && tables.length && _.isEqual(currentTable, previousTable)) {
            setCurrentTableRef(container);
            setCurrentTable(tables);
        }
    })

    useEffect(() => {
        dispatch({ type: sagaActions.RESET_APPTS_LIST_ACTION });
        setShowLoading(true);
        setAllApptsArr([]);
        setCurrentFilterSelected({ name: 'All Status' })
        // setTimeout(() => {
        //     fetchAppts()
        // }, [500])
    }, [])

    useEffect(() => {
        if (myAppointmentsListResponse && myAppointmentsListResponse.data.length) {
            setShowLoading(false);
            setAllApptsArr(myAppointmentsListResponse.data)
        } else {
            setAllApptsArr([])
            setShowLoading(false)
        }

    }, [myAppointmentsListResponse])

    //used to fetch appointments based on the filters
    useEffect(() => {
        if (currentFilterSelected && selectedStartDate && selectedEndDate) {
            fetchAppts(1, PaginationDefaultLimit, searchStr)
        }
    }, [currentFilterSelected, currentUserTypeFilterSelected, selectedStartDate, selectedEndDate, currentWarehouseFilterSelected])

    const getWarehouseIDForReportFilter = (currentWarehouseFilterSelected, selectedWarehouse) => {
        if (currentWarehouseFilterSelected?.ID && allowPermission) {
            return currentWarehouseFilterSelected?.ID
        } else if (!currentWarehouseFilterSelected?.ID && allowPermission) {
            return null
        } else {
            return selectedWarehouse.ID
        }
    }



    const fetchAppts = (pageNo = 1, limit = PaginationDefaultLimit, searchParams) => {
        setShowLoading(true);
        const apiParams = {
            "ID": userType === 'CARRIER' ? userAccountDetails?.IDCarrier : getWarehouseIDForReportFilter(currentWarehouseFilterSelected, selectedWarehouse),
            // "ID": userType === 'CARRIER' ? userAccountDetails?.IDCarrier : selectedWarehouse.ID,
            "type": userType === 'CARRIER' ? 'carrier' : 'warehouse',
            "pageNo": pageNo,
            "limit": limit,
            "searchParam": searchParams ? searchParams : null,
            "StartDate": selectedStartDate ? getLocalDateString(selectedStartDate) : null,
            "EndDate": selectedEndDate ? getLocalDateString(selectedEndDate) : null,
            "ApptStatus": currentFilterSelected?.name ? currentFilterSelected?.name === 'All Status' ? 'All' : currentFilterSelected?.name : null,
            "UserTypeFilter": currentUserTypeFilterSelected?.name === 'All User' ? null : currentUserTypeFilterSelected?.name,
            "CompanyID": allowPermission ? currentWarehouseFilterSelected?.ID ? null : selectedWarehouse.CompanyID : null
            // "CompanyID": currentWarehouseFilterSelected.ID ? null : selectedWarehouse.CompanyID
        }
        dispatch({ type: sagaActions.MY_APPTS_LIST_ACTION, payload: apiParams });
    }

    const fetchApptsReportHistoryDetails = (apptNumber) => {
        // const apiParams = {
        //     "AppointmentNumber": apptNumber
        // }
        // dispatch({ type: sagaActions.GET_APPOINTMENT_REPORT_HISTORY, payload: apiParams });
        setapptNumber(apptNumber)
        setShowAppointmentHistoryModal(true)
    }


    useEffect(() => {
        if (searchStr && searchStr.length > 3) {
            setTimeout(() => {
                fetchapptList(searchStr)
            }, 1000)
        } else if (searchStr === '') {

            fetchapptList(null)
        }
    }, [searchStr])

    const fetchapptList = (searchParams = null, pageNo = 1, limit = PaginationDefaultLimit,) => {
        fetchAppts(pageNo, limit, searchParams);
    }

    const getApptSchStatusColor = (str) => {
        if (str === 'Completed') {
            return <p className='text-success'>{str}</p>
        } else if (str === 'Complete') {
            str = 'Completed';
            return <p className='text-success'>{str}</p>
        } else if (str === 'Schedule') {
            str = 'Scheduled';
            return <p className='notScheStatusText'>{str}</p>
        } else if (str === 'Delete') {
            return <p className='text-danger'>{cancelObj[str]}</p>
        } else if (str === 'Re-Schedule') {
            return <p className='notScheStatusText'>{cancelObj[str]}</p>
        } else {
            return <p className='notScheStatusText'>{str}</p>
        }
    }

    const documentModelHandler = (el) => {
        if (showUploadDocsModal) {
            setapptNumber(null)
        } else {
            setapptNumber(el?.AppointmentNumber)
        }
        setShowUploadDocsModal(!showUploadDocsModal)
    }


    const fetchUploadDocsDataForAppt = () => {
        if (apptNumber) {
            dispatch({ type: sagaActions.INTIATE_SS_LOADER, payload: true })
            let fd = new FormData();
            fd.append('AppointmentNumber', apptNumber)
            fd.append('file', null); // Assuming 'file' is the file object
            fd.append('docName', null); // Append the document name
            fd.append('ApptDocsCreatedBy', null);
            fd.append('ApptDocsUpdatedBy', null);
            fd.append('CRUDTYPE', 'S');
            dispatch({
                type: sagaActions.UPLOAD_APPT_DOCS,
                payload: {
                    CRUDTYPE: 'S',
                    uploadData: fd
                }
            });
        }
    }

    const getActions = (el) => {
        return (
            <div className='d-flex justify-content-evenly'>
                <span onClick={() => documentModelHandler(el)}><i className="fa-solid fa-file text-grey fa-lg" title='Show Attachments'></i></span>
                <span onClick={() => {
                    setSelectedPo(el)
                    setShowPoDetailsModal(true)
                }}><i className="fa-solid fa-circle-info text-grey fa-lg" title='Show More Details'></i></span>

            </div>
        )
    }

    const returnCreatedBy = (el) => {
        return (
            <div className="d-flex flex-column">
                <span>{el.Username || '-'}</span>
                <span>{el.Usertype === 'USER' ? 'Warehouse' : el.Usertype || '-'}</span>
            </div>
        )
    }

    const formatListDataDrillDown = (data) => {
        // data[0] is the main/parent PO record; data[1+] are associated PO accordion child rows
        const mainEl = data[0];

        return data.map((el, index) => {
            // For associated PO child rows (index > 0), fall back to the main record's
            // values for CreatedBy (Username/Usertype), ReasonCode, and Reason when missing
            const effectiveEl = index > 0 ? {
                ...el,
                Username: el.Username || mainEl.Username,
                Usertype: el.Usertype || mainEl.Usertype,
                ReasonCode: el.ReasonCode || mainEl.ReasonCode,
                Reason: el.Reason || mainEl.Reason,
                TransDate: el.TransDate || mainEl.TransDate
            } : el;

            if (userType === 'CARRIER') {
                return {
                    id: el.RoleID,
                    0: index + 1,
                    1: <span style={{ textDecoration: 'underline', color: 'blue' }} onClick={() => fetchApptsReportHistoryDetails(el.AppointmentNumber)}>{el.AppointmentNumber}</span>,
                    2: el.PoNumber,
                    3: el?.WarehouseNameWithExternalSiteID || '-',
                    4: el.DueDate ? moment(el.DueDate).utc().format('MM/DD/YYYY') : '-',
                    5: el.ApptStartTime ? moment(el.ApptStartTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    6: el.DockName || '-',
                    // 7: el.BuyerName || '-',
                    8: el.Pallets || '-',
                    9: el.ItemsCases || '-',
                    10: effectiveEl.TransDate ? moment(effectiveEl.TransDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    11: el.ApptCreatedName ? el.ApptCreatedName : '-',
                    12: returnCreatedBy(effectiveEl),
                    13: el.ApptScheStatus ? getApptSchStatusColor(el.ApptScheStatus) : '-',
                    14: effectiveEl.ReasonCode ? effectiveEl.ReasonCode : '-',
                    15: effectiveEl.Reason ? effectiveEl.Reason : '-',
                    16: el.TransDate ? moment(el.TransDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    17: getActions(el)
                }
            }
            else {
                const getWarehouseColumn = () => {
                    let columns = {
                        id: el.RoleID,
                        0: index + 1,
                        1: <span style={{ textDecoration: 'underline', color: 'blue' }} onClick={() => fetchApptsReportHistoryDetails(el.AppointmentNumber)}>{el.AppointmentNumber}</span>,
                        2: el.PoNumber,
                        3: el?.CarrierName || '-',
                        4: el.DueDate ? moment(el.DueDate).utc().format('MM/DD/YYYY') : '-',
                        5: el.ApptStartTime ? moment(el.ApptStartTime).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-',
                    };

                    if (allowPermission) {
                        columns[6] = el?.WarehouseNameWithExternalSiteID || '-';
                        columns[7] = el.DockName || '-';
                        // columns[8] = el.BuyerName || '-';
                        columns[9] = el.Pallets || '-';
                        columns[10] = el.ItemsCases || '-';
                        columns[11] = effectiveEl.TransDate ? moment(effectiveEl.TransDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[12] = returnCreatedBy(effectiveEl);
                        columns[13] = el.ApptScheStatus ? getApptSchStatusColor(el.ApptScheStatus) : '-';
                        columns[14] = effectiveEl.ReasonCode ? effectiveEl.ReasonCode : '-';
                        columns[15] = effectiveEl.Reason ? effectiveEl.Reason : '-';
                        columns[16] = getActions(el);
                    } else {
                        columns[6] = el.DockName || '-';
                        // columns[7] = el.BuyerName || '-';
                        columns[8] = el.Pallets || '-';
                        columns[9] = el.ItemsCases || '-';
                        columns[10] = effectiveEl.TransDate ? moment(effectiveEl.TransDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '-';
                        columns[11] = returnCreatedBy(effectiveEl);
                        columns[12] = el.ApptScheStatus ? getApptSchStatusColor(el.ApptScheStatus) : '-';
                        columns[13] = effectiveEl.ReasonCode ? effectiveEl.ReasonCode : '-';
                        columns[14] = effectiveEl.Reason ? effectiveEl.Reason : '-';
                        columns[15] = getActions(el);
                    }

                    return columns;
                };

                return getWarehouseColumn();
            }

        })
    }

    const cancelObj = {
        'Delete': 'Cancelled',
        'Re-Schedule': 'Rescheduled'
    }
    const toggleModal = () => {
        setShowAppointmentHistoryModal(!showAppointmentHistoryModal);
    }

    const formatdata = (data) => {
        if (!data.length) {
            return;
        }
        // let result = []
        // const tempArr = data.map(ele => {
        //     if (ele.PORelationID === ele.PoNumber) {
        //         return ({ ...ele, masterPO: true })
        //     }
        //     else {
        //         return ({ ...ele, masterPO: false })
        //     }
        // })
        // let newlist = _.groupBy(tempArr, 'AppointmentNumber')
        // let finaldata = Object.values(newlist);
        // finaldata.forEach(element => {
        //     let l = element.sort((a, b) => {
        //         if (a.masterPO) {
        //             return -1;
        //         } else {
        //             return 1;
        //         }
        //     })
        //     result.push(l)
        // });
        let result = data?.map(el => {
            if (el?.associatedPO && el?.associatedPO.length) {
                return [el, ...el?.associatedPO]
            } else {
                return [el]
            }
        })
        // Sort each sub-array based on ApptStartTime
        //  const sortedResponse = result.map(subArray => _.orderBy(subArray, ['ApptEndTime'], ['asc']));
        const sortedResponse = result.map(subArray => [subArray[0], ..._.orderBy(subArray.splice(1, _.size(subArray) - 1), ['ApptEndTime'], ['asc'])]);
        // Sort the main array based on the ApptStartTime of the first element in each sub-array
        const finalSortedResponse = _.sortBy(sortedResponse, subArray => subArray[0]?.ApptEndTime);
        return finalSortedResponse;
    }


    const getBodyData = () => {
        if (allApptsArr.length) {
            const formatedData = formatdata(allApptsArr);
            return (formatedData.map((data, index) => {
                return (
                    formatListDataDrillDown(data, index)
                )
            }))
        }
        else {
            return []
        }
    }
    const pageChange = (pageNo, limit = PaginationDefaultLimit) => {
        fetchAppts(pageNo, limit, searchStr)
    }

    const downloadData = (type) => {
        let payload = {
            heading: "Appointment report",
            subDomain: "appointmentreport",
            downloadType: type,
            fileName: "AppointmentReport-" + userAccountDetails?.UserName + "-" + Date.now(),

            options: {
                startDate: null,
                endDate: null,
                ID: userType === 'CARRIER' ? userAccountDetails?.IDCarrier : getWarehouseIDForReportFilter(downloadWarehouseFilterSelected, selectedWarehouse),
                type: userType === 'CARRIER' ? 'carrier' : 'warehouse',
                CompanyID: allowPermission ? downloadWarehouseFilterSelected?.ID ? null : selectedWarehouse.CompanyID : null
            },
            userDetails: {
                CUID: userAccountDetails?.CUID,
            }
        }
        return payload
    }

    //Call Download Report API
    const downloadReport = (payload) => {
        dispatch({ type: sagaActions.DOWNLOAD_REPORT_COMMON, payload });
    }

    /**
     * Navigates to the My Reports section and closes the download popup.
     */
    const handleMyReports = () => {
        dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP });
        navigate('/myreports');
    }

    //Colums List for download column specific report
    const columnListWarehouse = [
        {
            name: "Appt Number",
            value: "AppointmentNumber"
        },
        {
            name: "PO",
            value: "PoNumber"
        },
        {
            name: "Warehouse",
            value: "WarehouseNameWithExternalSiteID"
        },
        {
            name: "Carrier",
            value: "CarrierName"
        },
        {
            name: "Due Date",
            value: "DueDate",
            isDate: true
        },
        {
            name: "Appt-Time",
            value: "ApptStartTime",
            isDate: true,
            isTime: true
        },
        {
            name: "Dock",
            value: "DockName"
        },
        // {
        //     name:"Buyer",
        //     value:"BuyerName"
        // },
        {
            name: "Pallets",
            value: "Pallets"
        },
        {
            name: "Created On",
            value: "TransDate",
            isDate: true,
            isTime: true
        },
        {
            name: "Created By",
            value: "Username",
            isCancelledType: true
        },
        {
            name: "Status",
            value: "ApptScheStatus"
        },
        {
            name: "Reason-Code",
            value: "ReasonCode"
        },
        {
            name: "Reason",
            value: "Reason"
        },
        {
            name: "Vehicle Type",
            value: "vehicleType"
        },
        {
            name: "Load Type",
            value: "orderType"
        }
    ]

    const columnListCarrier = [
        {
            name: "Appt Number",
            value: "AppointmentNumber"
        },
        {
            name: "PO",
            value: "PoNumber"
        },
        {
            name: "Warehouse",
            value: "WarehouseNameWithExternalSiteID"
        },
        {
            name: "Due Date",
            value: "DueDate",
            isDate: true
        },
        {
            name: "Appt-Time",
            value: "ApptStartTime",
            isDate: true,
            isTime: true
        },
        {
            name: "Dock",
            value: "DockName"
        },
        // {
        //     name:"Buyer",
        //     value:"BuyerName"
        // },
        {
            name: "Pallets",
            value: "Pallets"
        },
        {
            name: "Created On",
            value: "TransDate",
            isDate: true,
            isTime: true
        },
        {
            name: "Scheduled By",
            value: "ApptCreatedName"
        },
        {
            name: "Created By",
            value: "Username",
            isCancelledType: true
        },
        {
            name: "Status",
            value: "ApptScheStatus"
        },
        {
            name: "Reason-Code",
            value: "ReasonCode"
        },
        {
            name: "Reason",
            value: "Reason"
        },
        {
            name: "Vehicle Type",
            value: "vehicleType"
        },
        {
            name: "Load Type",
            value: "orderType"
        }
    ]

    /**
     * used for the appointment report user type filter
     * @returns
     */
    const showCustomDropDownForUserTypeFilter = () => {
        const filterDataArr = [
            {
                name: 'All User',
            },
            {
                name: 'Carrier',
            },
            {
                name: 'Warehouse',
            }
        ]
        return (
            <div className='d-flex align-items-center ms-2'>
                <CustomDropDown themeSelected={themeSelected} data={filterDataArr} placeHolder={currentUserTypeFilterSelected?.name} onSelect={(event) => setCurrentUserTypeFilterSelected(event)} keyStr={'name'} />
            </div>
        )
    }

    /**
     * used for the appointment report status filter
     * @returns
     *
     *
     */
    const showCustomDropDownForFilters = () => {
        const filterDataArr = [
            {
                name: 'All Status',
            },
            {
                name: 'Completed',
            },
            {
                name: 'Scheduled',
            },
            {
                name: 'Rescheduled',
            },
            {
                name: 'Cancelled',
            }

        ]
        return (
            <div className='d-flex align-items-center'>
                <CustomDropDown themeSelected={themeSelected} data={filterDataArr} placeHolder={currentFilterSelected?.name} onSelect={(event) => setCurrentFilterSelected(event)} keyStr={'name'} />
            </div>
        )
    }

    const closeSelectPopopup = () => {
        dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP })
    }
    return (
        <div className='appointments-report-ss-wrapper p-3'>
            <div className='container-fluid createPo-wrapper-ss my-2 mx-3'>
                <h4>{'Appointments'}</h4>
                <div className='d-flex justify-content-end align-items-center all-appt-list-action-right'>
                    <div className='d-flex appt-report-header align-items-center'>
                        {/* Date Range Selector Dropdown */}
                        <div className='me-2'>
                            <CustomDropDown
                                themeSelected={themeSelected}
                                data={[
                                    { id: 'last30', name: 'Last 30 Days' },
                                    { id: 'last60', name: 'Last 60 Days' },
                                    { id: 'custom', name: 'Choose Date' },
                                ]}
                                placeHolder={dateRangeMode === 'last30' ? 'Last 30 Days' : dateRangeMode === 'last60' ? 'Last 60 Days' : 'Choose Date'}
                                onSelect={(event) => setDateRangeMode(event.id)}
                                keyStr={'name'}
                                maxChars={15}
                            />
                        </div>

                        {/* Custom date pickers — only visible in 'custom' mode */}
                        {dateRangeMode === 'custom' && (
                            <>
                                <div className="pos-rel">
                                    <div className='d-flex align-items-center'>
                                        <button
                                            className={`date-picker-btn h-100 mx-2 ${initateLoading && 'disabled'}`}
                                            onClick={() => setShowStartDate(!showStartDate)}
                                            disabled={initateLoading}
                                        >
                                            <span className="btn-title">{selectedStartDate ?
                                                formatDate_MM_DD_YYYY(selectedStartDate) : 'Start Date'}</span>
                                            <i
                                                className="fa-regular fa-calendar"
                                                style={{ marginInline: "9px" }}
                                            ></i>
                                        </button>
                                        {showStartDate && <div className="appt-summary-ss-datePicker" >
                                            <DatePickerSS
                                                maxDate={selectedEndDate ? new Date(selectedEndDate) : new Date()}
                                                setSelectedDate={(date) => {
                                                    setSelectedStartDate(date);
                                                    setSelectedEndDate(null);
                                                    setShowStartDate(false);
                                                }}
                                                selectedDate={selectedStartDate}
                                                closeCalendar={() => setShowStartDate(!showStartDate)}
                                            />
                                        </div>
                                        }
                                    </div>
                                </div>
                                <div className="pos-rel">
                                    <div className='d-flex align-items-center'>
                                        <button
                                            className={`date-picker-btn h-100 mx-2 ${initateLoading && 'disabled'}`}
                                            onClick={() => setShowEndDate(!showEndDate)}
                                            disabled={initateLoading}
                                        >
                                            <span className="btn-title">{selectedEndDate ?
                                                formatDate_MM_DD_YYYY(selectedEndDate) : 'End Date'}</span>
                                            <i
                                                className="fa-regular fa-calendar"
                                                style={{ marginInline: "9px" }}
                                            ></i>
                                        </button>
                                        {showEndDate &&
                                            <div className="appt-summary-ss-datePicker">
                                                <DatePickerSS
                                                    minDate={selectedStartDate ? new Date(selectedStartDate) : undefined}
                                                    maxDate={
                                                        selectedStartDate
                                                            ? new Date(
                                                                Math.min(
                                                                    new Date(new Date().getFullYear(), 11, 31).getTime(),
                                                                    new Date(new Date(selectedStartDate).setMonth(new Date(selectedStartDate).getMonth() + 3)).getTime()
                                                                )
                                                            )
                                                            : new Date(new Date().getFullYear(), 11, 31)
                                                    }
                                                    setSelectedDate={(date) => {
                                                        setSelectedEndDate(date);
                                                        setShowEndDate(false);
                                                    }}
                                                    selectedDate={selectedEndDate}
                                                    closeCalendar={() => setShowEndDate(!showEndDate)}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className='mx-2'>
                        <WarehouseFiltersForReports currentWarehouseFilterSelected={currentWarehouseFilterSelected} setCurrentWarehouseFilterSelected={setCurrentWarehouseFilterSelected} themeSelected={themeSelected} />
                    </div>
                    {currentFilterSelected?.name ?
                        showCustomDropDownForFilters() : ''
                    }
                    {showCustomDropDownForUserTypeFilter()}
                    <div className='pos-rel ps-2'>
                        <WarehouseSearchSS
                            placeholder={AppConstant.poManagement.searchPOSection.searchTitleStr}
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)} />
                    </div>
                    <div className='d-flex align-items-center mx-3'>
                        <DownloadSectionBECustomFeilds isSchedulePro={true} downloadData={downloadData} isLoading={isDownloadLoading} isDisabled={isDownloadLoading} columnList={userType === 'CARRIER' ? columnListCarrier : columnListWarehouse} downloadReport={downloadReport}
                            showEmail={true}
                            emailValue={userAccountDetails && userAccountDetails.Email ? userAccountDetails.Email : ""}
                            showDateRange={true}
                            showApptStatus={true}
                            allowPermission={allowPermission}
                            showWarehouseFilter={allowPermission}
                            currentWarehouseFilterSelected={downloadWarehouseFilterSelected}
                            setCurrentWarehouseFilterSelected={setDownloadWarehouseFilterSelected}
                            userType={userType}
                            showUserTypeFilter={true}
                            userTypeFilterListArr={[{ name: 'All User', id: 1 }, { name: 'Carrier', id: 2 }, { name: 'Warehouse', id: 3 }]}
                            userTypeFilterTitle="Scheduled By"
                            defaultStartDate={selectedStartDate}
                            defaultEndDate={selectedEndDate}
                            defaultApptStatus={currentFilterSelected?.name === 'All Status' ? 'All' : currentFilterSelected?.name}
                            defaultUserTypeFilter={currentUserTypeFilterSelected?.name}
                            onOpenPopup={() => setDownloadWarehouseFilterSelected(currentWarehouseFilterSelected)}
                        />
                        {/* <DownloadSectionBE isSchedulePro={true} downloadData={downloadData} isLoading={isDownloadLoading} isDisabled={isDownloadLoading}/> */}
                        {/* <DownloadSectionSS singlePageDownload={true} root={''} subRoot={''} name={'Appointments Report'} themeSelected={themeSelected} currentTable={currentTable} currentTableRef={currentTableRef} /> */}
                    </div>
                </div>
            <p className='text-danger mb-0 text-end' style={{ fontSize: 'small' }}>{AppConstant.appointmentReportSummary.dateFilterDisclaimer}</p>
            </div>
            <div className='allApptsListContainer-ss' ref={divRef}>
                <DrilldownTableSS
                    themeSelected={themeSelected}
                    bodyData={getBodyData()}
                    titleData={userType === 'CARRIER' ? apptsTitleDD : apptsTitleDDWH}
                    showCollapse={false}
                    showInput={false}
                    showSort={false}
                    hasCollapsableContent={true}
                    collapsableData={formatdata(allApptsArr)}
                    accordionPrimaryIndex={1}
                    arrangeOrder={arrangeOrder}
                    arrangeKey={arrangeKey}
                    drillDownReport={myAppointmentsList}
                    initiateDrillDownReport={showLoading}
                    loaderArray={userType === 'CARRIER' ? 17 : allowPermission ? 17 : 16}
                    sortingAction={sagaActions.SORT_SS_USER_TABLE}
                    subRoot={{ pathName: 'allApptsList' }}
                    showUTCTime={true}
                />
            </div>
            {!_.isEmpty(myAppointmentsListResponse) && myAppointmentsListResponse?.data?.length ?
                <div>
                    <CustomPaginationSS
                        pageChange={(pageNo, limit) => { pageChange(pageNo, limit) }}
                        pageNo={myAppointmentsListResponse.pageNo}
                        pageSize={myAppointmentsListResponse.limit}
                        totalElements={myAppointmentsListResponse.totalElements}
                        totalPages={Math.ceil(myAppointmentsListResponse.totalElements / myAppointmentsListResponse.limit)}
                        last={myAppointmentsListResponse.last}
                        first={myAppointmentsListResponse.first}
                        data={myAppointmentsListResponse.data}
                    />
                </div> : ""
            }
            {showAppointmentHistoryModal &&
                <ModalSS toggleModal={toggleModal}>
                    <AppointmentReportHistory
                        themeSelected={themeSelected}
                        data={apptNumber}
                    />
                </ModalSS>

            }
            {showUploadDocsModal ? <UploadSproDocumentsPopup showModal={showUploadDocsModal} setCloseModal={setShowUploadDocsModal} uploadDocsHandler={() => { }} docDeleteHandler={() => { }} appointmentDocumentsList={appointmentDocumentsList} showDelete={false} showUpload={false} initateLoading={initateLoading} /> : ''}
            {showPoDetailsModal ? <PoDetailsPopup showModal={showPoDetailsModal} setCloseModal={setShowPoDetailsModal} poData={{ ...selectedPo, WarehouseData: selectedPo.WarehouseDetails }} initateLoading={initateLoading} /> : ''}

            {isActiveCommanDownloadPopup ? <SSPopup {...popupshowMorePoObj} popupBtnHandler={(btnText) => {
                if (btnText === AppConstant.reports.downloadReportPopup.myReportsBtn) {
                    handleMyReports();
                } else {
                    dispatch({ type: sagaActions.CLOSE_COMMAN_DOWNLOAD_MESSAGE_POPUP });
                }
            }} closepopup={closeSelectPopopup} themeSelected={themeSelected} showModal={isActiveCommanDownloadPopup} /> : ''}
        </div>
    )
}

export default AllAppointmentsListSS